import React from 'react';
import classNames from 'classnames/bind';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { linkBasePc } from '@src/mobile/components/Link';
import { formatPeopleCount } from '@src/public/utils/format';
import styles from './index.css';
import { ListStore } from '../store';

const cx = classNames.bind(styles);

const Bottom = () => {
    const listStore = ListStore.useContainer();
    const { listStates } = listStore;
    const { id, allowComment, interactionRsp } = listStates;

    const isWarPage = id === '8r727OWpK5W';

    const formatInteractionRspComment = count => {
        if (count) {
            return formatPeopleCount(count);
        } else {
            return '抢沙发';
        }
    };

    return (
        <>
            <div className={styles.placeholder} />
            {isWarPage ? null : <div className={styles.wrap}>
                <div className={styles.content}>
                    <div className={styles.btnGroup}>
                        <div className={styles.btn}>
                            {allowComment ? (
                                <a href={`${location.href?.split?.('loc')?.[0]}loc/timeline/comment/${id}`} target="_blank">
                                    <div className={cx('btnIcon', 'iconComment')}>
                                        {interactionRsp ? (
                                            <div className={styles.commentNum}>
                                                {formatInteractionRspComment(interactionRsp.comment)}
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className={styles.btnText}>评论</div>
                                </a>
                            ) : (
                                <>
                                    <div className={cx('btnIcon', 'iconComment')} />
                                    <div className={styles.btnText}>评论</div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default errorBoundary(Bottom);
